import api_key from "../../assets/images/api-key-modal.png";

export default { api_key };
